
export function WhyDifferentSection() {
  return (
    <section className="py-12 sm:py-16 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid lg:grid-cols-2 gap-8 sm:gap-12 lg:gap-16 items-center">
          <div className="relative order-2 lg:order-1">
            <div className="relative space-y-4 sm:space-y-6">
              <div className="relative rounded-2xl sm:rounded-3xl overflow-hidden shadow-xl transform hover:scale-105 transition-transform duration-500">
                <img
                  alt="Resultados"
                  className="w-full h-48 sm:h-56 lg:h-64 object-cover object-top"
                  src="https://static.readdy.ai/image/35f0715deb3f0b80002922a6d1f4e543/4e6536156e166d60d05604d3f00dbb09.jpeg"
                />
              </div>
              <div className="relative rounded-2xl sm:rounded-3xl overflow-hidden shadow-2xl ml-6 sm:ml-8 lg:ml-12 transform hover:scale-105 transition-transform duration-500">
                <img
                  alt="Estudiante"
                  className="w-full h-56 sm:h-64 lg:h-80 object-cover object-top"
                  src="https://public.readdy.ai/ai/img_res/31f91335232853b30d11acaead9e0afb.jpg"
                />
              </div>
              <div className="absolute top-1/2 left-0 transform -translate-y-1/2 bg-yellow-400 text-gray-900 px-3 sm:px-4 lg:px-6 py-2 sm:py-3 rounded-lg sm:rounded-xl font-bold shadow-2xl whitespace-nowrap text-xs sm:text-sm lg:text-base">
                ✨ Resultados Reales
              </div>
            </div>
          </div>

          <div className="space-y-6 sm:space-y-8 order-1 lg:order-2">
            <div className="space-y-3 sm:space-y-4">
              <div className="flex items-center gap-2 text-emerald-600 font-semibold text-xs sm:text-sm uppercase tracking-wider">
                <div className="w-2 h-2 rounded-full bg-emerald-600"></div>
                Por Qué Elegirnos
              </div>
              <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-bold text-gray-900 leading-tight">
                ¿Por qué esta academia es diferente? 🎯
              </h2>
              <p className="text-sm sm:text-base lg:text-lg text-gray-600 leading-relaxed">
                Sabemos que hoy no basta con publicar contenido — lo que realmente convierte son anuncios inteligentes, funnels efectivos y estrategias que venden y aprovechan la inteligencia artificial para acelerar el proceso
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
              <div className="p-4 sm:p-5 lg:p-6 rounded-xl sm:rounded-2xl bg-gradient-to-br from-gray-50 to-white border border-gray-100 hover:shadow-lg hover:border-emerald-200 transition-all duration-300 cursor-pointer group">
                <div className="w-10 h-10 sm:w-12 sm:h-12 lg:w-14 lg:h-14 rounded-xl sm:rounded-2xl bg-gradient-to-br from-emerald-500 to-cyan-500 flex items-center justify-center mb-3 sm:mb-4 group-hover:scale-110 transition-transform">
                  <i className="ri-rocket-line text-white text-lg sm:text-xl lg:text-2xl"></i>
                </div>
                <h3 className="text-base sm:text-lg lg:text-xl font-bold text-gray-900 mb-1 sm:mb-2">Campañas que Venden</h3>
                <p className="text-xs sm:text-sm lg:text-base text-gray-600 leading-relaxed">Crea anuncios inteligentes que generan ventas desde el inicio</p>
              </div>

              <div className="p-4 sm:p-5 lg:p-6 rounded-xl sm:rounded-2xl bg-gradient-to-br from-gray-50 to-white border border-gray-100 hover:shadow-lg hover:border-emerald-200 transition-all duration-300 cursor-pointer group">
                <div className="w-10 h-10 sm:w-12 sm:h-12 lg:w-14 lg:h-14 rounded-xl sm:rounded-2xl bg-gradient-to-br from-emerald-500 to-cyan-500 flex items-center justify-center mb-3 sm:mb-4 group-hover:scale-110 transition-transform">
                  <i className="ri-whatsapp-line text-white text-lg sm:text-xl lg:text-2xl"></i>
                </div>
                <h3 className="text-base sm:text-lg lg:text-xl font-bold text-gray-900 mb-1 sm:mb-2">Venta por WhatsApp</h3>
                <p className="text-xs sm:text-sm lg:text-base text-gray-600 leading-relaxed">Aprende a vender efectivamente sin perder dinero</p>
              </div>

              <div className="p-4 sm:p-5 lg:p-6 rounded-xl sm:rounded-2xl bg-gradient-to-br from-gray-50 to-white border border-gray-100 hover:shadow-lg hover:border-emerald-200 transition-all duration-300 cursor-pointer group">
                <div className="w-10 h-10 sm:w-12 sm:h-12 lg:w-14 lg:h-14 rounded-xl sm:rounded-2xl bg-gradient-to-br from-emerald-500 to-cyan-500 flex items-center justify-center mb-3 sm:mb-4 group-hover:scale-110 transition-transform">
                  <i className="ri-flow-chart text-white text-lg sm:text-xl lg:text-2xl"></i>
                </div>
                <h3 className="text-base sm:text-lg lg:text-xl font-bold text-gray-900 mb-1 sm:mb-2">Escalar con VSL y Páginas web</h3>
                <p className="text-xs sm:text-sm lg:text-base text-gray-600 leading-relaxed">
                  Diseña embudos de venta + VSL que realmente convierten con IA
                </p>
              </div>

              <div className="p-4 sm:p-5 lg:p-6 rounded-xl sm:rounded-2xl bg-gradient-to-br from-gray-50 to-white border border-gray-100 hover:shadow-lg hover:border-emerald-200 transition-all duration-300 cursor-pointer group">
                <div className="w-10 h-10 sm:w-12 sm:h-12 lg:w-14 lg:h-14 rounded-xl sm:rounded-2xl bg-gradient-to-br from-emerald-500 to-cyan-500 flex items-center justify-center mb-3 sm:mb-4 group-hover:scale-110 transition-transform">
                  <i className="ri-user-star-line text-white text-lg sm:text-xl lg:text-2xl"></i>
                </div>
                <h3 className="text-base sm:text-lg lg:text-xl font-bold text-gray-900 mb-1 sm:mb-2">Metodología validada</h3>
                <p className="text-xs sm:text-sm lg:text-base text-gray-600 leading-relaxed">
                  Resultados todos los meses con nuestra metodología
                </p>
              </div>
            </div>

            <p className="text-sm sm:text-base lg:text-lg text-gray-700 font-medium">
              No necesitas conocimientos previos. Todo está estructurado para que puedas aplicar desde el primer día.
            </p>

            <a
              href="https://pay.hotmart.com/I103812749W?checkoutMode=10"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-emerald-600 font-semibold hover:gap-4 transition-all cursor-pointer text-sm sm:text-base"
            >
              Conoce nuestra metodología completa
              <i className="ri-arrow-right-line"></i>
            </a>

            <div className="flex gap-8 sm:gap-12 pt-4">
              <div>
                <div className="text-3xl sm:text-4xl lg:text-5xl font-bold bg-gradient-to-r from-emerald-600 to-cyan-600 bg-clip-text text-transparent">100%</div>
                <div className="text-gray-600 text-xs sm:text-sm mt-1 whitespace-nowrap">Práctico</div>
              </div>
              <div>
                <div className="text-3xl sm:text-4xl lg:text-5xl font-bold bg-gradient-to-r from-emerald-600 to-cyan-600 bg-clip-text text-transparent">24/7</div>
                <div className="text-gray-600 text-xs sm:text-sm mt-1 whitespace-nowrap">Soporte</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
